module.exports = __webpack_public_path__ + "img/close-red.748646c4.svg";